export default __webpack_public_path__ + "static/media/profile.77882878.jpeg";